
import { getBlackList, updateBlackList } from '@/api/game-discusstion-manage';
import { toast } from '@/utils/common';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() visible!: boolean;
  uids: string = '';
  loading: boolean = false;
  mounted() {
    // console.log('sdfsdfj');
    this.getBlackList();
  }
  async getBlackList() {
    try {
      const res = await getBlackList();
      if (res.code == 0) {
        this.uids = res.data.uids;
      } else {
        toast(res.msg);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async submit() {
    try {
      this.loading = true;
      const res = await updateBlackList({ uids: this.uids });
      if (res.code == 0) {
        // this.balckStr = res.data;
        toast('修改成功！');
        this.$emit('close');
      } else {
        toast(res.msg);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  handleClose() {
    this.$emit('close');
  }
}
